// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"b5abc971","341":"efd92202","438":"61d554eb","650":"4b89c8fb","706":"8950387c","726":"717496a2"}[chunkId] + ".chunk.js";
};